import styled from 'styled-components'

export const FlagWrapper = styled.div`
  position: relative;
  margin: 5px;
`

export const FlagIcon = styled.img`
  height: 30px;
  cursor: pointer;
  border: 0.5px solid black;
  border-radius: 50px;
  background: rgba(255, 255, 255, 1);
`

export const LanguageCode = styled.span`
  position: absolute;
  height: 30px;
  width: 30px;
  border: 0.5px solid black;
  border-radius: 50px;
  left: 0px;
  top: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 15px;
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
`
